import React, { FunctionComponent, ReactElement } from 'react';
import styles from './CircleIcon.module.css';

export const CircleIcon: FunctionComponent = (): ReactElement => {
  return (
    <div className={styles.wrapper} />
  );
};
